import Color from '../Color.mjs'
import IconAvatar from '../icons/IconAvatar.jsx'
import IconLetters from '../icons/IconLetters.jsx'

export default [
    [
        'GENERAL',
        '通用',

        <IconLetters
            fill="#fff"
            letters="K"
            textColor="#000"
        />
    ],

    [
        'ROLE',
        '角色',
        <IconAvatar color={Color.RED} />
    ],
]
